module.exports = __webpack_public_path__ + "img/car_service.b6500800.jpg";